import { createStyles, makeStyles, fade, Theme } from '@material-ui/core/styles';

import {
  BIG_MARGIN,
  colorsPalette,
  LARGE_MARGIN,
  MIDDLE_MARGIN,
  SMALL_MARGIN,
} from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      padding: BIG_MARGIN,
      background: colorsPalette.blackSecondary,
      borderRadius: 8,
      marginBottom: LARGE_MARGIN,
    },
    title: {
      marginBottom: MIDDLE_MARGIN,
    },
    infoWrapper: {
      width: `calc(100% + ${2 * SMALL_MARGIN}px)`,
      marginLeft: `-${SMALL_MARGIN}px`,
      marginRight: `-${SMALL_MARGIN}px`,
    },
    infoCol: {
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        padding: `0 ${SMALL_MARGIN}px`,
        '&:not(:last-child)': {
          borderRight: `1px solid ${fade(colorsPalette.white, 0.33)}`,
        },
      },
    },
  }),
);

export default useStyles;
